<h1 mat-dialog-title>
  {{title}}
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content contest-details no-focus">
  <permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="rolesUpdated($event)">
    <div *ngIf="contest" class="no-focus">
      <div *ngIf="contest.description" class="description"
           [innerHTML]="sanitizer.bypassSecurityTrustHtml(contest.description)"></div>

      <div class="additional-info">
        <span class="text-disabled-color"
              i18n="Contest Enrol Modal|Contest Enrol period section title@@contest-enrol-modal-period-section-title">
          Period:
        </span>
        {{contest.startsAt | date: 'medium'}} - {{contest.endsAt | date: 'medium'}}
      </div>

      <div class="additional-info">
        <span class="text-disabled-color subsection-header"
              i18n="Contest Enrol Modal|Contest Enrol price section title@@contest-enrol-modal-price-section-title">
          Price:
        </span>
        <span *ngIf="!freeEnrol && contest.price && contest.price > 0">
          {{contest.price / 100 * (group?.length || 1)}}
          <ng-container i18n="General|Currency UAH title@@general-currency-uah-title">UAH</ng-container>
        </span>
        <span *ngIf="freeEnrol || !contest.price || contest.price <= 0" class="color-green"
              i18n="Contest Enrol Modal|Contest Enrol free price title@@contest-enrol-modal-free-price-title">Free</span>
      </div>

      <div *ngIf="group && group.length > 0" class="additional-info">
        <span class="text-disabled-color subsection-header"
              i18n="Contest Enrol Modal|Contest Enrol users count section title@@contest-enrol-modal-users-count-section-title">
          Number of participants:
        </span>
        <span>
          {{group.length}}
        </span>
      </div>
    </div>
  </permission-checker>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button *ngIf="group && group.length > 0"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="payForGroup()"
              label="Payment"
              i18n-label="General|Payment action label@@general-payment-action-label"
              [multiAction]="contest !== undefined && !freeEnrol && contest.price !== undefined && contest.price > 0"
              [actions]="ctaActions"
              (actionClicked)="ctaActionSelected($event)"></app-button>

  <app-button *ngIf="!group || !group.length"
              label="Enrol"
              i18n-label="General|Enrol action label@@general-enrol-action-label"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"
              [multiAction]="contest !== undefined && !freeEnrol && contest.price !== undefined && contest.price > 0"
              [actions]="ctaActions"
              (actionClicked)="ctaActionSelected($event)"></app-button>
</div>
